import type { Option, Sorting } from '@tbitop/ui';
import { Filtering } from '@tbitop/ui';

export type ObjektSortColumns = 'name';
export type ObjektSorting = Sorting<ObjektSortColumns>;

export type ObjektFilters = {
  suchbegriff?: string;
};

const objektSortOptions: Option<ObjektSortColumns>[] = [
  { value: 'name', label: 'Name' },
];

type ObjektFilteringProps = {
  filterValues: ObjektFilters;
  onFilterChange: (values: ObjektFilters) => void;
  className?: string;
  onSortChange: (sorting: ObjektSorting) => void;
  sorting: ObjektSorting;
};

export const ObjektfilterAktionsAufgabeErstellen = ({ filterValues, sorting, onSortChange, onFilterChange, className }: ObjektFilteringProps) => (
  <Filtering
    sorting={sorting}
    onSortChange={onSortChange}
    sortOptions={objektSortOptions}
    className={className}
    onFilterValuesChange={onFilterChange}
    filterValues={filterValues}/>
);
